import React, { useEffect, useState } from 'react';
import CategorySlider from '../Components/Carousal/CategorySlider';
import Brands from './Products/Brands';
import axios from 'axios';
import Loading from './layouts/Loading';
import ProductCard from './ProductCard';
import FootProducts from './FootProducts';
import Slider from './Carousal/Slider';
import ProductSlider from './Carousal/ProductSlider';
import { useSelector } from 'react-redux';
import WhatsAppWidget from './WhatsAppWidget';

function Home() {
  const [brands, setBrands] = useState([]);
  const [latestCategories, setLatestCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [hotProducts, setHotProducts] = useState([]);
  const [randomProducts, setRandomProduct] = useState([]);
  const [needProducts, setNeedProducts] = useState([]);
  const [trending, setTrending] = useState([]);
  const [flashDeal, setFlashDeal] = useState([]);
  const [slider, setSlider] = useState([]);
  const [leftbanner, setLeftBanner] = useState([]);
  const [rightbanner, setRightBanner] = useState([]);
  const [bottombanner, setBottomBanner] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const weburl = useSelector(state => state.constants.weburl);
  const formatPhoneNumber = (number) => {
    let cleaned = number.replace(/\D/g, '');
    if (cleaned.startsWith('0')) {
      cleaned = cleaned.substring(1);
    }
    if (!cleaned.startsWith('92')) {
      cleaned = '92' + cleaned;
    }
    return cleaned;
  };

  const phoneNumber = formatPhoneNumber('03216189882');
  const welcomeMessage = 'Hello! I need some help with your products.';

  useEffect(() => {
    axios.get('api/fetch/fourcategorybrands')
      .then(res => {
        setBrands(res.data.brands || []);
        setProducts(res.data.products || []);
        setHotProducts(res.data.hotproducts || []);
        setRandomProduct(res.data.randomproducts || []);
        setNeedProducts(res.data.needthis || []);
        setTrending(res.data.trending || []);
        setLatestCategories(res.data.latestCategories || []);
        setLeftBanner(res.data.leftbanner || []);
        setRightBanner(res.data.rightbanner || []);
        setFlashDeal(res.data.flashdeal || []);
        setBottomBanner(res.data.bottombanner || []);
        setSlider(res.data.slider || []);
      })
      .catch(err => {
        console.error('Error fetching data:', err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="overflow-x-hidden">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div>
            {/* Displaying Section Conditionally */}
            <div className="px-2 w-full mb-14 h-auto grid xl:grid-cols-4 lg:grid-cols-4 sm:grid-cols-1 grid-cols-1 gap-6">
              <div className="h-[800px] lg:w-full xl:w-full sm:w-full w-full hidden xl:block lg:block md:block">
                {leftbanner.length > 0 ? (
                  <>
                    <div className="h-[200px] shadow-md rounded-lg mt-4 bg-sky-200 overflow-hidden">
                      <img
                        src={`${weburl}${leftbanner[0]?.image || 'default-image.jpg'}`}
                        alt="Banner"
                        className="w-full h-full object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                    <div className="h-[400px] lg:h-[400px] xl:h-[400px] md:h-[400px] shadow-md mt-4 rounded-lg bg-sky-200 overflow-hidden">
                      <img
                        src={`${weburl}${leftbanner[1]?.image || 'default-image.jpg'}`}
                        alt="Banner"
                        className="w-full h-full object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                    <div className="h-[200px] shadow-md rounded-lg bg-sky-200 mt-4 overflow-hidden">
                      <img
                        src={`${weburl}${leftbanner[2]?.image || 'default-image.jpg'}`}
                        alt="Banner"
                        className="w-full h-full object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                  </>
                ) : (
                  <div className="h-[800px] flex items-center justify-center">
                    <p>No left banners available</p>
                  </div>
                )}
              </div>

              <div className="h-[200px] lg:w-full xl:w-full sm:w-full w-full col-span-2 lg:mt-0 xl:mt-0">
                {slider.length > 0 ? (
                  <div className="h-[200px] lg:h-[400px] xl:h-[400px] md:h-[400px] w-full shadow-lg rounded-lg bg-sky-200 mt-4 overflow-hidden">
                    <Slider className="w-full h-full" slider={slider} />
                  </div>
                ) : (
                  <div className="h-[400px] flex items-center justify-center">
                    <p>No slider available</p>
                  </div>
                )}

                {bottombanner.length > 0 ? (
                  <>
                    <div className="xl:flex lg:flex md:flex hidden gap-2 w-full h-[200px] shadow-md rounded-lg mt-4">
                      <div className="w-1/2 h-[200px] shadow-md rounded-lg bg-sky-200 overflow-hidden">
                        <img
                          src={`${weburl}${bottombanner[0]?.image || 'default-image.jpg'}`}
                          alt="Banner"
                          className="w-full h-full object-center rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                        />
                      </div>
                      <div className="w-1/2 h-[200px] shadow-md rounded-lg bg-sky-200 overflow-hidden">
                        <img
                          src={`${weburl}${bottombanner[1]?.image || 'default-image.jpg'}`}
                          alt="Banner"
                          className="w-full h-full object-top object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                        />
                      </div>
                    </div>
                    <div className="hidden xl:block lg:block h-[200px] shadow-md rounded-lg mt-4 bg-sky-200 overflow-hidden">
                      <img
                        src={`${weburl}${bottombanner[2]?.image || 'default-image.jpg'}`}
                        alt="Banner"
                        className="w-full h-full object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                  </>
                ) : (
                  <div className="h-[400px] flex items-center justify-center">
                    <p>No bottom banners available</p>
                  </div>
                )}
              </div>

              <div className="h-[800px] lg:w-full xl:w-full sm:w-full w-full hidden xl:block lg:block md:block">
                {rightbanner.length > 0 ? (
                  <>
                    <div className="w-full bg-sky-500 mt-4 shadow-sm rounded-lg h-[200px] overflow-hidden">
                      <img
                        src={`${weburl}${rightbanner[0]?.image || 'default-image.jpg'}`}
                        alt="Banner"
                        className="w-full h-full object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                    <div className="w-full bg-sky-500 mt-4 shadow-sm rounded-lg h-[200px] overflow-hidden">
                      <img
                        src={`${weburl}${rightbanner[1]?.image || 'default-image.jpg'}`}
                        alt="Banner"
                        className="w-full h-full object-cover object-center rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                    <div className="w-full bg-sky-500 mt-4 shadow-sm rounded-lg h-[400px] overflow-hidden">
                      <img
                        src={`${weburl}${rightbanner[2]?.image || 'placeholder.png'}`}
                        alt="Banner right"
                        className="w-full h-full object-cover rounded-lg transition-all duration-700 ease-in-out hover:scale-105"
                      />
                    </div>
                  </>
                ) : (
                  <div className="h-[800px] flex items-center justify-center">
                    <p>No right banners available</p>
                  </div>
                )}
              </div>
            </div>

            {randomProducts.length > 0 && (
              <ProductSlider data={randomProducts} name={'Continue Your Shopping'} />
            )}

            {latestCategories.length > 0 && (
              <CategorySlider latestCategories={latestCategories} name={'Get it all right here'} />
            )}
            
            {needProducts.length > 0 && (
              <ProductSlider data={needProducts} name={'You are gonna need these'} />
            )}

            {brands.length > 0 && (
              <div className="w-11/12 mx-auto mt-4" data-aos="fade-up">
                <div className="p-2 mb-4 font-serif">
                  <h1 className="text-2xl font-bold">
                    Latest Brands
                  </h1>
                </div>
                <Brands brands={brands} />
              </div>
            )}

            {hotProducts.length > 0 && (
              <ProductSlider data={hotProducts} name={'Celebrate with these find for you'} />
            )}

            {trending.length > 0 && (
              <ProductSlider data={trending} name={'Trending items on sale'} />
            )}

            {flashDeal.length > 0 && (
              <ProductSlider data={flashDeal} name={'Flash Deal'} />
            )}
            
            {products.length > 0 && (
              <ProductCard data={products} listGrid={5} />
            )}

            <FootProducts latestCategories={latestCategories} latest={products} hotProducts={hotProducts} brands={brands} />
          </div>
        </>
      )}
         <WhatsAppWidget 
            phoneNumber={phoneNumber}
            welcomeText={welcomeMessage}
            brandName="Your Store Name"
          />
    </div>
  );
}

export default Home;